import { Injectable } from '@angular/core';
import { ResourceService } from '../../shared/resource.service';
import { CustomerReference } from './customer-reference';
import { CustomerReferenceSerializer } from './customer-reference.serializer';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CustomerReferenceService extends ResourceService<CustomerReference> {
  baseUrl = environment.serverUrl + 'reference/customers/';
  allSelected = false;

  constructor(http: HttpClient) {
    super(http, 'reference/customers/', new CustomerReferenceSerializer());
  }
}
